import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    Autocomplete,
    List,
    ListItem,
    TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Image from "../../Utils/getImage";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Order_raise = ({ assignDialog, setAssignDialog, mode, setgetOrder, selectedOrder, setgetSubOrder, selectedsubOrder }) => {
    //handle close

    const handleClose = () => {
        setAssignDialog(false);

    };
    // console.log(selectedOrder);

    const [admins, setAdmins] = useState([]);
    //fetch admins
    const fetchadmins = async () => {
        try {
            const response = await instance.get('/Admin/getAdmins');
            const filterdata = response?.data?.data?.filter((admin) => admin.role === 'Tailor');
            const formatteddata = filterdata?.map((employee, index) => ({
                sno: index + 1,
                employeeName: employee?.name,
                employeeId: employee?._id,
                employeeimage: employee?.profile_pic
            }))

            setAdmins(formatteddata);
        }
        catch (error) {
            console.log("error to fetch admins:", error.message)
        }

    }
    useEffect(() => {
        fetchadmins()
    }, [])



    //assign order
    const handleRaiseConsultations = async () => {
        try {
            const response = await instance.post('/Consultation/raiseConsultation',
                {
                    order_id: selectedOrder?._id,
                    customer_id: selectedOrder?.Customer?._id,
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetOrder(true)
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message)
        }
    }



    return (
        <>
            <React.Fragment>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={assignDialog}
                    className="admin-admins"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Raise Consultations
                        <Typography>
                            Please Raise Consultations through Order.
                        </Typography>
                    </DialogTitle>
                    <hr style={{ margin: "10px 0px" }} />
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <section className="add-admin">
                            <div className='add_emloyee-content-text'>
                                <Typography>
                                    Are you Sure You Want to Raise Consultations
                                </Typography>
                            </div>
                        </section>
                    </DialogContent>
                    <DialogActions>
                        <Button className="cancel-btn" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className="add-btn" onClick={handleRaiseConsultations}>Raise Consultations</Button>
                    </DialogActions>
                </BootstrapDialog>
            </React.Fragment>
        </>
    )
}

export default Order_raise;